import { render, staticRenderFns } from "./TripsTab.vue?vue&type=template&id=f705d244"
import script from "./TripsTab.vue?vue&type=script&lang=js"
export * from "./TripsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports